<template>
  <layout-content>
    <table-component />
    <template slot="top-buttons">
      <template>
        <tooltip v-if="!is_trunk_allowed" max-width="120" placement="bottom" theme="light">
          <div v-if="!is_trunk_allowed" slot="content" class="text-left">
            {{ $t('voice.trunk.button.tooltip') }}
          </div>

          <i-button
            slot="default"
            :disabled="!is_trunk_allowed"
            type="primary"
            size="large"
            @click="create_trunk"
          >
            {{ $t('voice.trunk.button.create') }}
          </i-button>
        </tooltip>

        <i-button
          v-else
          slot="default"
          :disabled="!is_trunk_allowed"
          type="primary"
          size="large"
          @click="create_trunk"
        >
          {{ $t('voice.trunk.button.create') }}
        </i-button>
      </template>
    </template>
  </layout-content>
</template>

<script>
  import TableComponent from '@voice/components/trunks-table';
  import { mapActions, mapGetters } from 'vuex';
  import { TrunkModalService } from '@voice/modals/TrunkModalService';

  export default {
    components: { TableComponent },
    data: () => ({}),
    computed: {
      ...mapGetters('core/auth', ['permissions']),

      is_trunk_allowed() {
        return this.permissions.manage_trunks_is_allowed;
      }
    },

    methods: {
      ...mapActions('voice/sip-trunks/table', ['getAsyncData']),

      create_trunk: function () {
        if (this.is_trunk_allowed) {
          TrunkModalService.create().on('success', () => this.getAsyncData());
        }
      }
    }
  };
</script>

<style lang="scss">
  .b-trunks__wrapper {
    display: flex;

    .custom-table-wrapper {
      width: 100%;
    }
  }

  .row-ips {
    td {
      &:nth-child(1),
      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7) {
        opacity: 0;
      }
    }
  }
</style>
